export const ADD_NOTI = 'noti/ADD_NOTI'
export const REMOVE_NOTI = 'noti/REMOVE_NOTI'
